import { fetchProfile, patchProfile } from '../api/profileApi';
import { getSessionToken } from '../auth/sessionToken';
import { extractProfileDisplaySummary } from '../utils/profileDisplaySummary';

function pickString(value: unknown): string {
  if (typeof value === 'string') {
    return value.trim();
  }
  return '';
}

/** PATCH empty profile fields after a lite login (Google, email OTP, or phone OTP). */
export async function seedProfileFromLiteLogin(hints: {
  email?: string;
  phone?: string;
  firstName?: string;
  lastName?: string;
}): Promise<void> {
  const token = getSessionToken();
  if (!token) {
    return;
  }

  let profileData: unknown;
  try {
    profileData = await fetchProfile();
  } catch {
    return;
  }

  const summary = extractProfileDisplaySummary(profileData, null, hints.email ?? null, token);
  const patch: Record<string, string> = {};

  const email = pickString(hints.email);
  if (email && !pickString(summary.email)) {
    patch.email = email;
  }
  const firstName = pickString(hints.firstName);
  if (firstName && !pickString(summary.firstName)) {
    patch.first_name = firstName;
  }
  const lastName = pickString(hints.lastName);
  if (lastName && !pickString(summary.lastName)) {
    patch.last_name = lastName;
  }
  const phone = pickString(hints.phone);
  if (phone && !pickString(summary.phone)) {
    patch.phone_number = phone;
  }

  if (Object.keys(patch).length === 0) {
    return;
  }

  try {
    await patchProfile(patch);
  } catch {
    /* profile hub still shows contact hints from login */
  }
}
